import { useNavigate } from "react-router-dom";

function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-[80vh] flex flex-col items-center justify-center text-center px-6">
      <h1 className="text-6xl font-bold text-primaryAccent mb-4">404</h1>

      <h2 className="text-2xl font-semibold text-headingText mb-3">
        Page not found
      </h2>

      <p className="text-descriptionText mb-8 max-w-md">
        The page you are looking for doesn’t exist or may have been moved.
      </p>

      <button
        onClick={() => navigate("/")}
        className="bg-primaryAccent text-white px-6 py-3 rounded-lg hover:bg-primaryAccentHover transition"
      >
        Go back home
      </button>
    </div>
  );
}

export default NotFound;
